module.exports = __webpack_public_path__ + "img/charm_1.be9c862e.svg";